export default {
  'schedules.list.header.actions': 'Ações',
  'schedules.list.column.actions.button': 'Avaliar',
  'schedules.list.column.actions.schedule': 'Agenda',

  'schedules.domain.requests.date': 'Data do agendamento',
  'schedules.domain.requests.time': 'Hora',
  'schedules.domain.requests.customer': 'Cliente',
  'schedules.domain.requests.customer.name': 'Nome do Cliente',
  'schedules.domain.requests.customer.email': 'E-mail',
  'schedules.domain.requests.customer.phone': 'Telefone',
  'schedules.domain.requests.vehicle': 'Veículo',
  'schedules.domain.requests.vehicle.brand': 'Marca',
  'schedules.domain.requests.vehicle.model': 'Modelo',
  'schedules.domain.requests.vehicle.year': 'Ano',
  'schedules.domain.requests.vehicle.color': 'Cor',
  'schedules.domain.requests.vehicle.renavam': 'Renavam',
  'schedules.domain.requests.service': 'Serviços',
  'schedules.domain.requests.workshop': 'Oficina',
  'schedules.domain.requests.observation': 'Observação',
  'schedules.domain.requests.employee': 'Colaborador',
  'schedules.domain.requests.status': 'Status',
  'schedules.domain.requests.entry': 'Entrada',
  'schedules.domain.requests.exit': 'Saída',
  'schedules.domain.requests.status.accepted': 'Aceito',
  'schedules.domain.requests.status.cancelled': 'Cancelado',
  'schedules.domain.requests.status.refused': 'Recusado',
  'schedules.domain.requests.status.requested': 'Solicitado',
  'schedules.domain.requests.dayType.none': 'Nenhum',
  'schedules.domain.requests.dayType.sunday': 'Domingo',
  'schedules.domain.requests.dayType.monday': 'Segunda',
  'schedules.domain.requests.dayType.tuesday': 'Terça',
  'schedules.domain.requests.dayType.wednesday': 'Quarta',
  'schedules.domain.requests.dayType.thursday': 'Quinta',
  'schedules.domain.requests.dayType.friday': 'Quinta',
  'schedules.domain.requests.dayType.saturday': 'Sábado',
  'schedules.domain.requests.serviceType.workshop': 'Oficina',
  'schedules.domain.requests.serviceType.bodywork': 'Funilaria',

  'schedules.requests.appointmentsDeclined': 'Agendamentos Recusados',
  'schedules.requests.filters.workshop': 'Filtrar por oficina',
  'schedules.requests.filters.date': 'Filtrar por data',
  'schedules.requests.filters.time': 'Filtrar por hora',

  'schedules.requests.modal.appointmentsDeclined.title':
    'Solicitações Recusadas',

  'schedules.requests.modal.title': 'Agendamento',
  'schedules.requests.modal.title.services': 'Serviços',
  'schedules.requests.modal.title.customers': 'Clientes',
  'schedules.requests.modal.title.vehicles': 'Veículo',
  'schedules.requests.modal.buttons.accept': 'Aceitar',
  'schedules.requests.modal.buttons.refuse': 'Recusar',

  'schedules.requests.edit.notication.success':
    'Agendamento editado com sucesso!',
  'schedules.requests.edit.notication.successDescription':
    'A data do agendamento foi editada com sucesso.',

  'schedules.requests.refuse.modal.title':
    'Gostaria de recusar esse agendamento?',
  'schedules.requests.refuse.modal.form.obs': 'Observação',
  'schedules.requests.refuse.modal.button.refuseText': 'Recusar',
  'schedules.requests.refuse.notication.success':
    'Agendamento recusado com sucesso!',
  'schedules.requests.refuse.notication.successDescription':
    'O agendamento foi recusado com sucesso.',
  'schedules.requests.accept.notication.success':
    'Agendamento aprovado com sucesso!',
  'schedules.requests.accept.notication.successDescription':
    'O agendamento foi aprovado com sucesso.',

  'schedules.requests.history.modal.title': 'Solicitações recusadas',
  'schedules.requests.history.modal.buttons.confirm': 'Confirmar',
  'schedules.requests.history.modal.buttons.close': 'Fechar',
  'schedules.requests.history.button.reOpen': 'Reabrir agendamento',
  'schedules.requests.history.reOpen.notication.success':
    'Agendamento reaberto',
  'schedules.requests.history.reOpen.notication.successDescription':
    'O agendamento foi reaberto com sucesso.',

  'schedules.scheduling.newSchedule': 'Novo Agendamento',
  'schedules.scheduling.modal.buttons.cancelText': 'Fechar',
  'schedules.scheduling.modal.buttons.okText': 'Salvar',
  'schedules.scheduling.modal.buttons.newOrder':
    'Transformar em ordem de serviço',
  'schedules.scheduling.update.notication.success': 'Agendamento atualizado!',
  'schedules.scheduling.update.notication.successDescription':
    'O agendamento foi atualizado com sucesso.',
  'schedules.scheduling.create.notication.success': 'Agendamento criado!',
  'schedules.scheduling.create.notication.successDescription':
    'O agendamento foi criado com sucesso.',

  'schedules.operation.label.selectCompany': 'Selecione uma empresa',
  'schedules.operation.title.manPower': 'Força de trabalho',
  'schedules.operation.title.workingDays': 'Dias de funcionamento',
  'schedules.operation.title.unavailableDays': 'Dia indisponível',
  'schedules.operation.manPower.form.qtdVehiclesByHours':
    'Qtde. de veículos por hora',
  'schedules.operation.manPower.form.qtdVehiclesByPeriod':
    'Qtde. de veículos por período',
  'schedules.operation.manPower.notication.success':
    'Força de trabalho atualizada!',
  'schedules.operation.manPower.notication.successDescription':
    'A força de trabalho da empresa foi atualizado com sucesso.',
  'schedules.operation.workingDays.notication.success':
    'Dias de funcionamento atualizados!',
  'schedules.operation.workingDays.notication.successDescription':
    'Os dias de funcionamento da empresa foram atualizados com sucesso.',
  'schedules.operation.unavailableDays.list.fields.allDay': 'Dia inteiro',
  'schedules.operation.unavailableDays.list.fields.observation': 'Observação',
  'schedules.operation.unavailableDays.list.buttons.addDate': 'Adicionar data',
  'schedules.operation.unavailableDays.list.buttons.removeDate': 'Excluir data',
  'schedules.operation.unavailableDays.notication.success':
    'Dias especiais atualizados com sucesso!',
  'schedules.operation.unavailableDays.notication.successDescription':
    'Os dias especiais foram associados com sucesso.',

  'schedules.services.table.description': 'Descrição',
  'schedules.services.table.serviceType': 'Tipo',
  'schedules.services.linkServices.notication.success':
    'Serviços associados com sucesso!',
  'schedules.services.linkServices.notication.successDescription':
    'Os serviços selecionados foram associados com sucesso.',

  'schedules.employee.table.workingDay': 'Jornada de trabalho',
  'schedules.employee.newJourney': 'Nova Jornada',
  'schedules.employee.newJourney.modal.title': 'Novo Colaborador',
  'schedules.employee.newJourney.modal.okText': 'Adicionar',
  'schedules.employee.newJourney.modal.cancelText': 'Fechar',
  'schedules.employee.newJourney.form.searchEmployee': 'Buscar Colaborador',
  'schedules.employee.newJourney.form.removeJourney': 'Excluir jornada',
  'schedules.employee.schedule.modal.title': 'Agenda',
  'schedules.employee.schedule.modal.okText': 'Salvar',
  'schedules.employee.schedule.table.changeEmployee': 'Trocar colaborador',
  'schedules.employee.schedule.table.followSchedule': 'Acompanhar agendamento',
};
